import React, { useState, useEffect, useContext } from 'react';
import moment from 'moment';
import { Timeline } from 'antd';
import $ from "jquery";
import Toaster from 'toastr';
import Loading from '../components/Loading';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import CommonUtils from "../util/CommonUtils";
import { Context } from './app';

function ThirdPartyMonitoring() {

    let appContex = useContext(Context);
    let user = appContex.user;
    let submitting = null;

    const [callflowLogData, setCallflowLogData] = useState([]);
    const [loading, setLoading] = useState(null);
    const [latestRecord, setLatestRecord] = useState({});
    const [comment, setComment] = useState('');
    const [editMode, setEditMode] = useState(false);
    const [showOldCallFlow, setShowOldCallFlow] = useState(false);

    useEffect(() => {
        fetchCallflowLog();
    }, [])

    const showLoading = (loadingMessage) => {
        setLoading(loadingMessage);
    }

    const fetchCallflowLog = () => {
        showLoading('Fetching ...');
        var data = {
            user_login: user.user_login,
            user_token: user.user_token,
            site_id: user.site_selected.site_id,
            form_input: {
                "query": JSON.stringify({
                    attributes: ['*'],
                    object: 'callflow_log',
                    filters: [
                        { operator: '!=', attribute: 'log_id', value: "" },
                    ],
                    sort_by: [{ attribute: 'log_id', value: 'asc' }],
                    pagination: { page: 1, size: 1000 }
                })
            }
        }

        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/data-explorer',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res && res.status && res.status.code === 200) {
                    let callflowLogData = res.data ? res.data : [];
                    let latestRecord = callflowLogData.length > 0 ? callflowLogData[callflowLogData.length - 1] : {};
                    console.log({ latestRecord })
                    let comment = latestRecord.comments ? latestRecord.comments : "";
                    setCallflowLogData(callflowLogData);
                    setLoading(false);
                    setLatestRecord(latestRecord);
                    setComment(comment);
                } else {
                    setLoading(false);

                }
            }
        )
    }

    const postComment = () => {
        if (comment.length > 500) {
            Toaster.error("Comment should not be greater than 500 char")
            return
        }

        let data = {
            user_login: user.user_login,
            user_token: user.user_token,
            site_id: user.site_selected.site_id,
            operation: "create",
            form_input: {
                object: "callflow_log",
                attributes: ["site_id", "comments", "created_by"],
                records: JSON.stringify([[user.site_selected.site_id, comment, user.user_login]]),
            }
        }

        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/data-explorer',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res && res.status && res.status.code === 200) {
                    setLoading(false);
                    setEditMode(false);
                    Toaster.success("Successfully generated");
                    fetchCallflowLog();
                } else {
                    setLoading(false);
                    setEditMode(false);
                    Toaster.error("Failed occured!");
                }
            }
        )
    }

    const deleteComment = (log_id) => {
        showLoading('Deleting ...');
        let data = {
            user_login: user.user_login,
            user_token: user.user_token,
            site_id: user.site_selected.site_id,
            operation: 'delete',
            form_input: {
                object: 'callflow_log',
                filters: JSON.stringify([{ attribute: 'log_id', value: log_id, operator: '=' }])
            }
        };

        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/data-explorer',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res && res.status && res.status.code === 200) {
                    setLoading(false);
                    Toaster.success("Deleted Successfully");
                    fetchCallflowLog();
                } else {
                    Toaster.error("Failed occured!");
                }
            }
        )
    }

    const updateState = () => {
        setEditMode(false);
        setComment(latestRecord.comments);
    }

    let EditorModules = {
        toolbar: [
            [{ 'font': [] }],
            [{ size: [] }],
            ['bold', 'italic', 'underline'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }]
        ],
        clipboard: {
            matchVisual: false,
        }
    };
    let EditorFormats = [
        'header', 'font', 'size',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet'
    ];
    let hideEditTools = {
        toolbar: null,
    };
    let previousCallLog = [...callflowLogData];
    previousCallLog.pop();

    return (
        <React.Fragment>
            <div className="page-container btn-light-pointerless">
                <div className="card bg-shadow mt-4 ml-4">
                    <div className="card-body" style={{ "height": "390px" }}>
                        <div className="row">
                            {!loading && latestRecord.log_id &&
                                <div className="col-md-8">
                                    <i className="fa fa-user"></i> <span className="font-size-12 text-primary">{latestRecord.created_by}</span><br />
                                    <i className="fa fa-clock"></i> <span className="font-size-12 text-app">{moment(latestRecord.created_ts).format('YYYY-MM-DD HH:mm:ss')}</span><br />
                                </div>
                            }
                            {!loading && latestRecord.log_id && CommonUtils.hasPermission('SITESUPT-UI-SECURITY-USER-CALL-FLOW') &&
                                <div className="col-md-4 text-right">
                                    <i className="fa fa-edit text-primary cursor-pointer mr-3"
                                        onClick={() => {
                                            setEditMode(true);
                                        }}>
                                    </i>
                                    <i className="fa fa-trash text-danger cursor-pointer mr-1"
                                        onClick={() => deleteComment(latestRecord.log_id)}>
                                    </i>
                                </div>
                            }
                        </div>
                        {!loading && latestRecord.log_id && editMode ?
                            <div>
                                <ReactQuill
                                    onChange={(value) => setComment(value)}
                                    value={comment}
                                    modules={EditorModules}
                                    formats={EditorFormats}
                                    bounds={'.app'}
                                />
                            </div> :
                            (!loading && latestRecord.log_id && <ReactQuill
                                value={comment}
                                modules={hideEditTools}
                                bounds={'.app'}
                                theme='snow'
                                readOnly
                            />)
                        }
                        {comment.length > 0 && editMode &&
                            <>
                                <button className="btn btn-sm btn-primary pull-right mt-2" onClick={postComment} disabled={latestRecord.comments === comment}>Save</button>
                                <button className="btn btn-sm btn-light pull-right mt-2 mr-3" onClick={() => updateState()}>Cancel</button>
                            </>
                        }
                        {loading && <Loading>{loading}</Loading>}
                        {!loading && callflowLogData && callflowLogData.length === 0 && <span className="text-primary font-size-12"><i className="fa fa-info-circle"></i> No third party monitoring available</span>}
                    </div>
                    {!loading && CommonUtils.hasPermission('SITESUPT-UI-SECURITY-USER-CALL-FLOW') && callflowLogData.length === 0 && <div className="card-footer">
                        <div>
                            <ReactQuill
                                onChange={(value) => setComment(value)}
                                value={comment}
                                modules={EditorModules}
                                formats={EditorFormats}
                                bounds={'.app'}
                                placeholder='Max. 500 chars'
                            />
                        </div>
                        <button
                            className="btn btn-sm btn-primary pull-right mt-2"
                            type="button"
                            disabled={comment.trim().length === 0 || comment === "<p><br></p>"}
                            loading={submitting}
                            onClick={postComment}
                        >
                            Create a call flow
                        </button>
                    </div>}
                </div>
                {previousCallLog.length > 0 && <div className='card bg-shadow mt-4 ml-4'>
                    <div className='card-header'>
                        <b className='text-primary'>Previous Call Flow</b>
                        <span className='pull-right'>
                            <i className={showOldCallFlow ? "fa fa-angle-up" : "fa fa-angle-down"} style={{ cursor: "pointer" }} onClick={() => setShowOldCallFlow(!showOldCallFlow)}></i>
                        </span>
                    </div>
                    <div className='card-body' hidden={!showOldCallFlow}>
                        <Timeline>
                            {previousCallLog.map((c) => {
                                return <Timeline.Item key={c.log_id}>
                                    <div className="row">
                                        <div className="col-md-8">
                                            <i className="fa fa-user"></i> <span className="font-size-12 text-primary">{c.created_by}</span><br />
                                            <i className="fa fa-clock"></i> <span className="font-size-12 text-app">{moment(c.created_ts).format('YYYY-MM-DD HH:mm:ss')}</span><br />
                                        </div>
                                    </div>
                                    <ReactQuill
                                        value={c.comments}
                                        id={c.log_id}
                                        modules={hideEditTools}
                                        bounds={'.app'}
                                        theme='snow'
                                        readOnly
                                    />
                                </Timeline.Item>
                            })}
                        </Timeline>
                    </div>
                </div>}
            </div>
        </React.Fragment>
    );
}

export default ThirdPartyMonitoring;